module.exports = __webpack_public_path__ + "img/Leeane.6aca127d.jpeg";